import { defaultZodCatch } from '@/lib/converters/defaultZodCatch'
import { priceValueConverter } from '@/lib/converters/priceValue/priceValueConverter'
import { zProductPrice } from '@/schemas/productPriceSchema'

import type { PriceValueDto as ResponseDto } from '@/gen/bff'
import type { ProductPriceSchema } from '@/schemas/productPriceSchema'

export const productPriceConverter = (data: ResponseDto): ProductPriceSchema => {
  const response: ProductPriceSchema = {
    productId: data?.productId ?? '',
    quantity: data?.quantity ?? 0,
    price: data != null ? priceValueConverter(data) : null,
  }

  return zProductPrice.catch(defaultZodCatch).parse(response)
}
